import FileUpload from '@nkr/components/file-upload';
import { Col, Row } from 'react-bootstrap';
import YesNoUnknown from '../yes-no-unknown';
import { FileDocumentType } from '@nkr/enums/document-type';

interface IProps {
    adpFormPath: string,
    voucherConsentsReviewed: boolean,
    newConsentFile: File,
    onViewFile: (docType: FileDocumentType) => void,
    onChangeFile: (file: File) => void,
    onRemoveFile: () => void,
    onConsentsReviewedChange: (name: string, value: boolean) => void
}

const AdpContent = (props: IProps) => {
    const handleFileDropped = (acceptedFiles: File[]) => {
        props.onChangeFile(acceptedFiles[0]);
    };

    const handleRemoveFile = () => {
        props.onRemoveFile();
    };

    const handleChange = (name: string, value: boolean) => {
        if (name == 'voucherConsentsReviewed') {
            props.onConsentsReviewedChange('voucherConsentsReviewed', value);
        }
    };

    return (
        <>
            <div className='container-fluid donor-profile-adp adp'>
                <Row>
                    {props.adpFormPath != '' && (
                        <>
                            <Col xs={12} lg={3}>
                                <label>Current Form on File:&nbsp;</label>
                            </Col>
                            <Col xs={12} lg={3}>
                                <div className='form-control-static'>
                                    <a style={{ cursor: 'default' }} onClick={() => props.onViewFile(FileDocumentType.DonorAdp)}>download file</a>
                                </div>
                            </Col>
                        </>
                    )}

                    <Col xs={12} lg={2} style={{ paddingTop: 7 }}>
                        <label>Upload Consent Form:&nbsp;</label>
                    </Col>

                    <Col xs={12} lg={4}>
                        <FileUpload
                            label='Click here to select the file or drag &amp; drop the file here...'
                            files={props.newConsentFile != null ? [props.newConsentFile] : []}
                            height='30px'
                            accept='.pdf'
                            onFileDropped={handleFileDropped}
                            singleUploadOnly={false}
                            onRemoveFile={handleRemoveFile} />
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={3}>
                        <label>
                            Voucher Consent Reviewed:
                        </label>
                    </Col>
                    <Col xs={12} lg={4}>
                        <YesNoUnknown
                            name='voucherConsentsReviewed'
                            yes={props.voucherConsentsReviewed == true}
                            no={props.voucherConsentsReviewed == false}
                            unknown={props.voucherConsentsReviewed == null}
                            onChange={handleChange} />
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default AdpContent;
